import { EShopCategory } from '@r1-frontend/api-domru/api-content/v1/shop/items/requestDto';
import { IEquipmentCategory } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/EquipmentCategory.dto';
import { IEquipmentTestDrive } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/EquipmentTestDrive.dto';

import format from '@r1-frontend/ui-react/components/costs/Cost/format';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { NBSP } from '@r1-frontend/ui-react/tokens/symbols';
import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';
import { dayPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

const equipmentTextByCategory: Record<string, string> = {
    [EShopCategory.Routers]: 'роутера',
    [EShopCategory.YandexStation]: 'умной колонки',
    [EShopCategory.YandexStationLite]: 'умной колонки',
    [EShopCategory.Decoders]: 'приставки',
};

const pluralizeDays = getPluralize(dayPluralize);

export const getBannerData = (testDrive: IEquipmentTestDrive, category?: IEquipmentCategory) => {
    const { duration, priceDuring } = testDrive;
    const { name = '' } = category || {};

    return {
        title: `Тест-драйв на${NBSP}${duration}${NBSP}${pluralizeDays(duration)}`,
        description: <Paragraph5>
            Протестируйте все возможности {equipmentTextByCategory[name] ?? 'оборудования'} за&nbsp;{format(priceDuring)}. <ControlElement type={'small'}>Подробнее</ControlElement>
        </Paragraph5>,
        image: {
            url: require('~/static/images/equipment/test-drive/banner.png'),
            urlWebp: require('~/static/images/equipment/test-drive/banner.webp'),
        },
    };
};
